import { EntityType, ISelectOption } from '../../types';

interface ISelf {
  entityId: string;
  entityType: EntityType;
}
/**
 * @description determines the correct entityType and entityId
 * @param selectedOption
 * @param self
 * @returns [entityType, entityId]
 */
export const determinePopulation = (
  selectedOption: ISelectOption<string>,
  self: ISelf
): [string, string] => {
  if (selectedOption.value === 'self') return [self.entityType, self.entityId];
  const parts = selectedOption.value.split(':');
  return [parts[0], parts[1]];
};
